"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _underscore = _interopRequireDefault(require("underscore"));

var _backbone = _interopRequireDefault(require("backbone"));

var _bootstrap = _interopRequireDefault(require("bootstrap"));

var _Global = _interopRequireDefault(require("models/Global"));

var _SubmissionForm = _interopRequireDefault(require("../../scripts/models/SubmissionForm"));

var _RegistrationFieldsCollection = _interopRequireDefault(require("../../scripts/models/RegistrationFieldsCollection"));

var _GoogleMapsLoader = _interopRequireDefault(require("../../editor-templates/scripts/GoogleMapsLoader"));

var _LandingCountdownView = _interopRequireDefault(require("../../editor-templates/scripts/LandingCountdownView"));

var _ContactsElementRenderView = _interopRequireDefault(require("../../editor-templates/scripts/ContactsElementRenderView"));

var _FormView = _interopRequireDefault(require("../../scripts/views/FormView"));

var _SocialButtonsView = _interopRequireDefault(require("../../editor-templates/scripts/SocialButtonsView"));

var _jqueryReadmore = _interopRequireDefault(require("jquery-readmore"));

var _config = _interopRequireDefault(require("config"));

var _whitelabelUtils = require("../../scripts/utils/whitelabelUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SectionRenderMixin = {
  elementsRender: {
    countdownClock: 'renderCountdown',
    tickets: 'renderTicketsWidget',
    sponsors: 'renderPopOverOnHover',
    exhibitors: 'renderPopOverOnHover',
    form: 'renderForm',
    people: 'peopleRender',
    socialShare: 'renderSocialShare',
    iframe: 'renderCodeElement',
    downloadApp: 'renderDownloadApp',
    attendees: 'renderAttendees'
  },
  returnAsModel: function returnAsModel(obj) {
    // In the editor we pass the element as a model and in attendee as a JSON
    if (!(obj instanceof _backbone.default.Model)) {
      return new _backbone.default.Model(obj);
    } else {
      return obj;
    }
  },
  renderAttendees: function renderAttendees() {
    var swapImageToDefault = function swapImageToDefault(event) {
      event.target.src = '/images/home/empty_placeholder.png';
      event.target.style = 'border-radius: 50%';
      (0, _jquery.default)(event.target).next().removeClass('hide');
    };

    this.$el.find('img.attendee-photo-img').on('error', swapImageToDefault);
  },
  renderDownloadApp: function renderDownloadApp(element) {
    var event = _Global.default.get('event');

    var base = (0, _whitelabelUtils.getInternalWebsiteBaseUrl)(event.toJSON());
    var path = "".concat(base, "/deeplink");
    event.get('linkToAppAndroid') && this.$('.js-download-android').attr('href', "".concat(path, "/android"));
    event.get('linkToAppiOS') && this.$('.js-download-ios').attr('href', "".concat(path, "/ios"));
  },
  renderCodeElement: function renderCodeElement(element) {
    if (window.location.search) {
      this.$('.iframe_not_editor_mode_wrapper').attr('src', element.url += window.location.search);
    }
  },
  renderCountdown: function renderCountdown(element) {
    var model = this.returnAsModel(element);
    model.set('timeZone', _Global.default.get('event').get('time-zone-id'));
    var countdownView = new _LandingCountdownView.default({
      el: this.$('.js-countdown-view'),
      model: model
    });
    countdownView.render();
    this.subViews.push(countdownView);
  },
  peopleRender: function peopleRender(element) {
    var contactsElementRenderView = new _ContactsElementRenderView.default({
      el: this.$('.js-contacts-element'),
      model: this.returnAsModel(element)
    });
    contactsElementRenderView.render();
    this.subViews.push(contactsElementRenderView);
  },
  renderTicketsWidget: function renderTicketsWidget(element) {
    if (this.$('.bizzabo-tickets-widget').length > 0) {
      var eventId = _Global.default.get('event').get('id');

      try {
        // `bz-query-string` is also stored as a constant in @bizzabo/website-sections
        var bzQueryString = window.sessionStorage.getItem("bz-query-string-".concat(eventId));
        this.$('.bizzabo-tickets-widget').attr('data-bz-query-string', bzQueryString);
      } catch (error) {
        console.warn('Could not access session storage due to privacy settings');
      }

      this.$('.bizzabo-tickets-widget').attr('data-dashboard-url', _config.default.dashboardUrl); // Ticket widget snippet code

      var bz = document.createElement('script');
      bz.type = 'text/javascript';
      bz.async = true;
      bz.src = _config.default.organizerUrl + '/widgets/tickets/tickets.js';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(bz, s);
    }
  },
  renderPopOverOnHover: function renderPopOverOnHover(element) {
    var thisView = this;

    function hide(e) {
      (0, _jquery.default)('[data-toggle="popover"]').each(function () {
        if (!(0, _jquery.default)(e.data.sponsor).is(e.target) && (0, _jquery.default)(e.data.sponsor).has(e.target).length === 0 && (0, _jquery.default)('.popover').has(e.target).length === 0) {
          (0, _jquery.default)(e.data.sponsor).popover('hide');
          (0, _jquery.default)('body').off('click', hide);
        }
      });
    }

    var hidePopoverOnClickOutside = function hidePopoverOnClickOutside(e) {
      (0, _jquery.default)('body').on('click', {
        sponsor: e.target || {}
      }, hide);
    };

    var popoverView = {
      render: function render() {
        thisView.$('[data-toggle=popover]').popover({
          template: '<div class="popover description" role="button"><div class="arrow"></div><h3 class="popover-title description-title"></h3><div class="popover-content desc-popover-content"></div></div>',
          trigger: 'click',
          html: true,
          content: function content() {
            return (0, _jquery.default)('#ToolMenu').html();
          },
          container: 'body',
          title: 'Toolbox'
        }).on('shown.bs.popover', hidePopoverOnClickOutside);
      },
      remove: function remove() {
        thisView.$('[data-toggle=popover]').popover('destroy');
      }
    };
    popoverView.render();
    this.subViews.push(popoverView);
  },
  renderSocialShare: function renderSocialShare() {
    var socialButtonsView = new _SocialButtonsView.default({
      el: this.$('.social-share-buttons-holder')
    });
    this.subViews.push(socialButtonsView);
  },
  renderForm: function renderForm(element) {
    var formModel = this.returnAsModel(element);
    var separators = formModel.get('formSeparators') || [];

    var model = _SubmissionForm.default.findOrCreate(_underscore.default.extend(formModel.get('form'), {
      eventId: _Global.default.get('event').get('id'),
      buttonName: formModel.get('buttonName'),
      layout: formModel.get('layout'),
      successMessage: formModel.get('successMessage'),
      separators: separators,
      customLegal: formModel.get('customLegal'),
      showCustomLegal: formModel.get('showCustomLegal'),
      additionalTerms: formModel.get('additionalTerms'),
      showAdditionalTerms: formModel.get('showAdditionalTerms'),
      additionalTermsMandatory: formModel.get('additionalTermsMandatory')
    }), {
      parse: true
    });

    var formView = new _FormView.default({
      el: this.$('.form-view-holder'),
      model: model,
      separators: separators
    });
    formView.render();
    this.subViews.push(formView);
  }
};
var _default = SectionRenderMixin;
exports.default = _default;